import { useQuery } from '@tanstack/react-query';

import { serviceApi } from '~/features';
import type { UnregisteredStatusResponse } from '~/types/monitoring';

export const GET_UNREGISTERED_STATUS_QUERY_KEY =
  'GET_UNREGISTERED_STATUS_QUERY';

/**
 * Calcula a criticidade baseada na quantidade de mensagens:
 * - Verde: ≤10.000 mensagens → "Normal"
 * - Amarelo: 10.001–30.000 → "Atenção"
 * - Vermelho: >30.000 → "Crítico"
 */
const calculateCriticality = (
  quantity: number
): {
  color: 'VERDE' | 'AMARELO' | 'VERMELHO';
  status: 'Normal' | 'Atenção' | 'Crítico';
} => {
  if (quantity <= 10000) {
    return { color: 'VERDE', status: 'Normal' };
  }
  if (quantity <= 30000) {
    return { color: 'AMARELO', status: 'Atenção' };
  }
  return { color: 'VERMELHO', status: 'Crítico' };
};

/**
 * Processa os dados da API e calcula a criticidade para cada item
 */
const processStatusData = (
  rawData: UnregisteredStatusResponse
): UnregisteredStatusResponse => {
  return rawData.map(item => {
    const { color, status } = calculateCriticality(item.quantity);
    return {
      ...item,
      color,
      status,
    };
  });
};

function getUnregisteredStatus() {
  return serviceApi.get<UnregisteredStatusResponse>(
    '/DashboardMonitoramentoCampanhas/status'
  );
}

export function useGetUnregisteredStatus(enabled = true) {
  return useQuery({
    queryKey: [GET_UNREGISTERED_STATUS_QUERY_KEY],
    queryFn: getUnregisteredStatus,
    staleTime: 1000 * 60, // 1 minuto
    enabled,
    select: data => {
      // Processar e calcular criticidade baseada nas quantidades
      return processStatusData(data.data);
    },
  });
}
